import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TableHeaderDirective } from '@app/shared/components/organisms/table/directives/table-header.directive';
import { CellDirective } from '@app/shared/components/organisms/table/directives/cell.directive';
import { ColumnHeaderDirective } from '@app/shared/components/organisms/table/directives/column-header.directive';
import { TableCellDirective } from '@app/shared/components/organisms/table/directives/table-cell.directive';
import { RowDirective } from '@app/shared/components/organisms/table/directives/row.directive';
import { RowCellsDirective } from '@app/shared/components/organisms/table/directives/row-cells.directive';
import { RowHeadersDirective } from '@app/shared/components/organisms/table/directives/row-headers.directive';
import { StickyDirective } from '@app/shared/components/organisms/table/directives/sticky.directive';
import { ColumnDirective } from '@app/shared/components/organisms/table/directives/column.directive';
import { CollapseRowDirective } from '@app/shared/components/organisms/table/directives/collapse-row.directive';
import { CollapseCellDirective } from '@app/shared/components/organisms/table/directives/collapse-cell.directive';
import { TableDirective } from '@app/shared/components/organisms/table/directives/table.directive';

@NgModule({
  imports: [TableDirective],
  declarations: [
    CellDirective,
    CollapseCellDirective,
    CollapseRowDirective,
    ColumnDirective,
    ColumnHeaderDirective,
    RowCellsDirective,
    RowDirective,
    RowHeadersDirective,
    StickyDirective,
    TableHeaderDirective,
    TableCellDirective,
  ],
  exports: [
    RowDirective,
    ColumnHeaderDirective,
    StickyDirective,
    CellDirective,
    TableCellDirective,
    TableHeaderDirective,
    ColumnDirective,
    RowCellsDirective,
    RowHeadersDirective,
  ],
  providers: [RouterLink],
})
export class SharedModule {
  static forRoot() {
    return {
      ngModule: SharedModule,
    };
  }
}
